import { useState, useEffect } from 'react';
import { jiraApi } from '../lib/api';

// Most recent live (non-demo) Jira sync time, or null until real projects are
// synced. Refreshes when a sync completes (the 'jira-synced' window event).
// Shared by the header and sidebar so the staleness reference stays consistent.
export function useJiraLastSync(): string | null {
  const [lastSyncedAt, setLastSyncedAt] = useState<string | null>(null);
  useEffect(() => {
    const load = () => jiraApi.lastSync().then(r => setLastSyncedAt(r.data?.lastSyncedAt ?? null)).catch(() => {});
    load();
    window.addEventListener('jira-synced', load);
    return () => window.removeEventListener('jira-synced', load);
  }, []);
  return lastSyncedAt;
}

// "May 24, 1:30 PM" — compact date + time for the sync indicators.
export function formatSyncTime(iso: string): string {
  const d = new Date(iso);
  const date = d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  const time = d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  return `${date}, ${time}`;
}
